exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form-item[data-v-1db7038c]{margin-bottom:18px}.audit-log-form[data-v-1db7038c]{margin-top:18px}.audit-log-empty[data-v-1db7038c]{color:#606266}", ""]);

// exports
